import { downloadDirectoryItemBlob } from '../files.service'
import { ActionResult, DirectoryItem } from '../types'
import { ExecutableAction } from './action'

async function downloadItem(item: DirectoryItem): Promise<ActionResult> {
  if (item.type === 'file') {
    await downloadDirectoryItemBlob(item)
    return {
      status: 'success',
      data: undefined,
      message: `Downloaded ${item.name}`
    }
  } else {
    alert(`Cannot download ${item.type}: ${item.name}`)
    return {
      status: 'info',
      message: `Cannot download non-file item: ${item.name}`
    }
  }
}

export class DownloadAction extends ExecutableAction {
  static readonly actionName = 'download'
  public readonly actionName = DownloadAction.actionName

  constructor(private readonly items: DirectoryItem[]) {
    super()
  }

  override async execute(): Promise<ActionResult> {
    if (this.items.length > 0) {
      let filesToDownload = 0
      for (const item of this.items) {
        if (item.type === 'file') {
          const result = await downloadItem(item)
          if (result.status !== 'success') {
            return { status: 'info', message: result.message || `Cannot download ${item.name}` }
          }
          filesToDownload++
        }
      }
      if (filesToDownload === 0) {
        alert('No files selected for download.')
      } else if (filesToDownload < this.items.length) {
        alert('Downloaded selected files. Other selected items were not files.')
      }
    } else {
      alert('Please select file(s) to download.')
    }
    return { status: 'success', data: undefined, message: 'Download action executed.' }
  }

  override async undo(): Promise<ActionResult> {
    return { status: 'success', data: undefined }
  }
}
